angular.module('eStories.privacy', [
    'eStories.account.model'
])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.privacy', {
                url: 'privacy',
                views: {
                    'mainView@': {
                        templateUrl: 'terms/privacy.tmpl.html',
                        controller: 'PrivacyCtrl as privacyCtrl'
                    }
                }
            })
            .state('eStories.navbars.privacyCenter', {
                url: 'privacyCenter',
                views: {
                    'mainView@': {
                        templateUrl: 'terms/privacyCenter.tmpl.html',
                        controller: 'PrivacyCenterCtrl as privacyCenterCtrl'
                    }
                }
            });
    }])

    .controller('PrivacyCtrl',
        [
            'AccountModel',
            '$scope',
            'GA',
            '$location',
            function (AccountModel,
                      $scope,
                      GA,
                      $location) {

                var privacyCtrl = this;

                GA.trackPageView($location.path());


                AccountModel.getLocation().then(function (response) {
                    if (response == null || response.responseStatus !== "SUCCESS") {
                        return;
                    }
                    privacyCtrl.countryCode = response.country.code;
                    privacyCtrl.currency = response.country.currency;
                    safeApply($scope);
                });

            }
        ]
    )
    .controller('PrivacyCenterCtrl',
        [
            'AccountModel',
            '$scope',
            '$location',
            'ModalsModel',
            function (AccountModel,
                      $scope,
                      $location,
                      ModalsModel) {

                var privacyCenterCtrl = this;

                AccountModel.getLocation().then(function (response) {
                    if (response == null || response.responseStatus !== "SUCCESS") {
                        return;
                    }
                    privacyCenterCtrl.currency = response.country.currency;
                    safeApply($scope);
                });

                privacyCenterCtrl.tryToGoToAccountPage = () => {
                    if (AccountModel.isUserLoggedIn) {
                        $location.path('/account/overview');
                    } else {
                        ModalsModel.open('/registration/signInModal.tmpl.html', 'RegistrationCtrl', 'regCtrl');
                    }
                };

                privacyCenterCtrl.openConfirmAccountHolderModal = (dataHandlingPreference) => {

                    let item = {
                        injectedItem: function () {
                            return dataHandlingPreference;
                        },
                    };
                    ModalsModel.open('/terms/modals/confirmAccountSignIn.tmpl.html', 'PrivacySignInCtrl', 'privacySignInCtrl', null, item);
                };

                privacyCenterCtrl.closePrivacyBanner = () => {
                    localStorage.setItem("GDPRPrivacyBannerDismissed", true);
                };

                privacyCenterCtrl.showPrivacyBanner = () => {
                    let cookie = localStorage.getItem("GDPRPrivacyBannerDismissed");

                    return !(cookie === "true") &&
                        (privacyCenterCtrl.currency === 'EUR' || privacyCenterCtrl.currency === 'GBP');
                }
            }
        ]
    )
    .controller('PrivacySignInCtrl',
        [
            'AccountModel',
            '$scope',
            '$location',
            'RegistrationModel',
            '$uibModalInstance',
            '$rootScope',
            'ValidationModel',
            'injectedItem',
            'ModalsModel',
            function (AccountModel,
                      $scope,
                      $location,
                      RegistrationModel,
                      $uibModalInstance,
                      $rootScope,
                      ValidationModel,
                      injectedItem,
                      ModalsModel) {

                let privacySignInCtrl = this;

                if (injectedItem) {
                    privacySignInCtrl.handleDataPreference = injectedItem;
                }
                /*EMAIL SIGN IN*/
                privacySignInCtrl.submitSignIn = async function () {
                    if (!privacySignInCtrl.freeOfErrors()) {
                        return;
                    }

                    privacySignInCtrl.serverError = null;
                    let signInObj = {
                        email: privacySignInCtrl.email,
                        password: privacySignInCtrl.password,
                        device: RegistrationModel.getDeviceObj(),
                    };

                    const response = await RegistrationModel.submitSignIn(signInObj);
                    privacySignInCtrl.handleSignInResponse(response);
                };

                privacySignInCtrl.handleSignInResponse = function (response) {
                    if (response != null && response.responseStatus === 'SUCCESS') {
                        if (privacySignInCtrl.handleDataPreference) {
                            if (privacySignInCtrl.handleDataPreference === 'sendData') {
                                //    open sendto email input modal
                                privacySignInCtrl.closeRegModal();
                                let item = {
                                    injectedItem: function () {
                                        return privacySignInCtrl.handleDataPreference;
                                    }
                                };
                                ModalsModel.open('/terms/modals/sendDataToEmail.tmpl.html', 'PrivacyConfirmCtrl', 'privacyConfirmCtrl', null, item);
                            } else if (privacySignInCtrl.handleDataPreference === 'deleteData') {
                                //   delete data request to server and callback confirmation modal
                                privacySignInCtrl.closeRegModal();
                                ModalsModel.open('/terms/modals/confirmAccountDeletion.tmpl.html', 'PrivacyConfirmCtrl', 'privacyConfirmCtrl');
                            }
                        }
                    } else {
                        let errorMessage;
                        switch (response.responseText) {
                            case 'INTERNAL_ERROR':
                                errorMessage = 'Unable to login due to an internal error. We apologize for the inconvenience, please try again.';
                                break;
                            case 'INVALID_EMAIL':
                                //given when the user's email isn't formatted right.
                                errorMessage = 'Incorrect Email. The email you entered doesn\'t appear to be formatted correctly.  Please try again.';
                                break;
                            case 'USER_NOT_FOUND':
                                errorMessage = 'Password does not match username. Please try again.';
                                break;
                            case 'INCORRECT_PASSWORD':
                                errorMessage = 'Incorrect Password. The password you entered does not match our records.' +
                                    ' Please try again or reset password.';
                                break;
                            case 'DEVICE_LIMIT_EXCEEDED':
                                errorMessage = 'You have exceeded the limit on the number of devices that can access this account.';
                                break;
                            default:
                                errorMessage = 'Internal Error (' + response.responseText + ')';
                                break;
                        }
                        privacySignInCtrl.serverError = errorMessage;
                    }
                };

                $scope.$on('modal.closing', function () {
                    privacySignInCtrl.serverError = null;
                });

                privacySignInCtrl.closeRegModal = function () {
                    angular.element('body').css('padding', '0');
                    $uibModalInstance.close();
                };

                /*LOCAL VALIDATIONS*/

                privacySignInCtrl.formErrors = {};

                privacySignInCtrl.freeOfErrors = function () {
                    let obj = privacySignInCtrl.formErrors;
                    return Object.keys(obj).length === 0 && JSON.stringify(obj) === JSON.stringify({});
                };

                privacySignInCtrl.validateFullName = function (fullName) {
                    return ValidationModel.validateFullName(fullName, privacySignInCtrl.formErrors);
                };

                privacySignInCtrl.validateEmail = function (email) {
                    return ValidationModel.validateEmail(email, privacySignInCtrl.formErrors);
                };

                privacySignInCtrl.validatePassword = function (password) {
                    return ValidationModel.validatePassword(password, privacySignInCtrl.formErrors);
                };

                privacySignInCtrl.validateConfirmPassword = function (password, confirmPassword) {
                    return ValidationModel.validateConfirmPassword(password, confirmPassword, privacySignInCtrl.formErrors);
                };

                privacySignInCtrl.getFieldClass = function (fieldName, fieldValue, isTypingInProgress) {
                    return ValidationModel.getFieldClass(fieldName, fieldValue, privacySignInCtrl.formErrors, isTypingInProgress);
                };

                /*FACEBOOK SIGN IN*/
                privacySignInCtrl.submitFacebookSignIn = async function () {
                    const response = await RegistrationModel.submitFacebookSignIn();
                    privacySignInCtrl.handleSignInResponse(response);
                };

                /*GOOGLE SIGN IN*/
                privacySignInCtrl.submitGoogleSignIn = async function () {
                    const response = await RegistrationModel.submitGoogleSignIn();
                    privacySignInCtrl.handleSignInResponse(response);

                };

            }
        ]
    )
    .controller('PrivacyConfirmCtrl',
        [
            '$uibModalInstance',
            'AccountModel',
            'ModalsModel',
            'ValidationModel',

            function ($uibModalInstance,
                      AccountModel,
                      ModalsModel,
                      ValidationModel) {

                let privacyConfirmCtrl = this;

                privacyConfirmCtrl.formErrors = {};

                privacyConfirmCtrl.getUserEmail = function () {
                    if (AccountModel.userDetails) {
                        return AccountModel.userDetails.email;
                    }
                };

                privacyConfirmCtrl.closeModal = () => {
                    angular.element('body').css('padding', '0');
                    $uibModalInstance.close();
                };

                privacyConfirmCtrl.validateEmail = function (email) {
                    return ValidationModel.validateEmail(email, privacyConfirmCtrl.formErrors);
                };

                privacyConfirmCtrl.freeOfErrors = function () {
                    let obj = privacyConfirmCtrl.formErrors;
                    return Object.keys(obj).length === 0 && JSON.stringify(obj) === JSON.stringify({});
                };

                privacyConfirmCtrl.closeRegModal = function () {
                    angular.element('body').css('padding', '0');
                    $uibModalInstance.close();
                };


                privacyConfirmCtrl.sendDataToUser = async () => {
                    const response = await AccountModel.requestPrivacyDataDump(privacyConfirmCtrl.email);
                    if (response && response.responseStatus === 'SUCCESS') {
                        $uibModalInstance.close();
                        ModalsModel.open('/terms/modals/dataRequestSentConfirmation.tmpl.html', 'PrivacyRequestConfirmationCtrl', 'privacyRequestConfirmationCtrl');
                    } else {
                        if (response.responseText === 'INVALID_TO_EMAIL') {
                            privacyConfirmCtrl.serverError = 'This email is invalid - please try again';
                        } else {
                            privacyConfirmCtrl.serverError = response.responseText;
                        }
                    }
                };

                privacyConfirmCtrl.confirmAccountDeletion = async () => {
                    privacyConfirmCtrl.inProgress = true;
                    const response = await AccountModel.requestAccountDeletion();
                    $uibModalInstance.close();
                    ModalsModel.open('/terms/modals/dataRequestSentConfirmation.tmpl.html', 'PrivacyRequestConfirmationCtrl', 'privacyRequestConfirmationCtrl');
                };

                privacyConfirmCtrl.inProgress = false;

            }
        ]
    )
    .controller('PrivacyRequestConfirmationCtrl',
        [
            '$uibModalInstance',

            function ($uibModalInstance) {

                let privacyRequestConfirmationCtrl = this;

                privacyRequestConfirmationCtrl.closeModal = () => {
                    angular.element('body').css('padding', '0');
                    $uibModalInstance.close();
                };
            }
        ]
    );
